/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShow = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M2 12s2.105-7 10-7 10 7 10 7-2.105 7-10 7-10-7-10-7m10 4.308c2.325 0 4.21-1.929 4.21-4.308 0-2.38-1.885-4.308-4.21-4.308S7.79 9.621 7.79 12c0 2.38 1.885 4.308 4.21 4.308" clipRule="evenodd" /></svg>;
export default SvgShow;